import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { DashboardLoadingIcon } from '@/components/Loaders';
import { useUserState } from '@/state';
import { LocaleNavigate } from '@/utils/locale';

/**
 * ProtectedRouteSimple
 *
 * Prosty protected route bez sidebar - tylko wymaga zalogowania.
 * Używane dla stron takich jak /create-organization.
 */
export const ProtectedRouteSimple: FC = () => {
  const { currentUser, isLoading, isResolved } = useUserState();

  // Czekaj na załadowanie danych użytkownika
  if (isLoading || !isResolved) {
    return (
      <div className="w-full h-[100vh] flex flex-col items-center justify-center">
        <DashboardLoadingIcon size="sm" />
      </div>
    );
  }

  // Jeśli nie zalogowany, przekieruj na login
  if (!currentUser) {
    return <LocaleNavigate to="/login" replace />;
  }

  // Renderuj children bez layoutu (bez sidebar)
  return <Outlet />;
};
